import { Login } from 'login/login';
import { PropsWithChildren } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { AuthLayout, PublicLayout } from 'shared/layouts';
import { ApprovalWorkflowPageResolver } from './approval-workflow-resolver';
import { AuthenticationRequired } from './authentication-required';
import { CopyQuoteResolver } from './copy-quote-resolver';
import { CustomerDetailsResolver } from './customer-details-resolver';
import { CustomerManagementResolver } from './customer-management-resolver';
import { EditQuoteResolver } from './edit-quote-resolver';
import { NewQuoteResolver } from './new-quote-resolver';
import { ProductManagementResolver } from './product-management-resolver';
import { QuoteReviewResolver } from './quote-review-resolver';
import { QuotesSummaryResolver } from './quotes-summary-resolver';
import { ROUTES } from './routes';
import { UnauthorizedResolver } from './unauthorized-resolver';

function Public({ children }: PropsWithChildren<{}>) {
  return <PublicLayout>{children}</PublicLayout>;
}

function Private({ children }: PropsWithChildren<{}>) {
  return (
    <AuthenticationRequired>
      <AuthLayout>{children}</AuthLayout>
    </AuthenticationRequired>
  );
}

function PrivateRoutes() {
  return (
    <Private>
      <Switch>
        <Route path={ROUTES.customerManagement} exact>
          <CustomerManagementResolver />
        </Route>
        <Route path={ROUTES.customerDetails}>
          <CustomerDetailsResolver />
        </Route>
        <Route path={ROUTES.productManagement} exact>
          <ProductManagementResolver />
        </Route>
        <Route path={ROUTES.approvalWorkflow}>
          <ApprovalWorkflowPageResolver />
        </Route>
        <Route path={ROUTES.quote} exact>
          <QuotesSummaryResolver />
        </Route>
        <Route path={ROUTES.quoteReview} exact>
          <QuoteReviewResolver />
        </Route>
        <Route path={ROUTES.newQuote} exact>
          <NewQuoteResolver />
        </Route>
        <Route path={ROUTES.editQuote} exact>
          <EditQuoteResolver />
        </Route>
        <Route path={ROUTES.copyQuote} exact>
          <CopyQuoteResolver />
        </Route>
        <Route path='*'>
          <Redirect to={ROUTES.login} />
        </Route>
      </Switch>
    </Private>
  );
}

export function AppRoutes() {
  return (
    <Switch>
      <Route path={ROUTES.login} exact>
        <Public>
          <Login />
        </Public>
      </Route>
      <Route path={ROUTES.unauthorized} exact>
        <Public>
          <UnauthorizedResolver />
        </Public>
      </Route>
      <Route path='*'>
        <PrivateRoutes />
      </Route>
    </Switch>
  );
}
